import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {ChatMessageThread} from 'llm/chat-library/ChatMessageThread';
import {ClientDisplayChatEvent} from 'llm/chat-library/messages/MessageTypes';
import {ProgressData} from 'llm/chat-library/progress/ProgressTypes';
import {LatestUserMessageInfo} from 'llm/ChatScrollTypes';
import {DeepResearchProgressData} from 'llm/deep-research/tool-details/types';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

export interface DeepResearchMessageThreadProps {
  chatSessionId: string;
  isLoading: boolean;
  messages: Array<ClientDisplayChatEvent>;
  progressData: ProgressData | null;
  openActivityModal: (activityData: DeepResearchProgressData, selectedToolId?: string) => void;
  onUpdateLatestUserMessageInfo?: ((info: LatestUserMessageInfo) => void) | null;
}

/**
 * Presentational component for rendering deep research messages.
 * Uses ChatMessageThread for rendering with the activity modal integration.
 */
export function DeepResearchMessageThread({
  chatSessionId,
  messages,
  progressData,
  onUpdateLatestUserMessageInfo,
  isLoading,
}: DeepResearchMessageThreadProps): JSX.Element {
  if (isLoading && messages.length === 0) {
    return (
      <CenteredHorizontalThrobber
        {...getTestProps({component: 'DeepResearchMessageThread', element: 'loading-throbber'})}
      />
    );
  }
  return (
    <ChatMessageThread
      events={messages}
      progressData={progressData}
      onUpdateLatestUserMessageInfo={onUpdateLatestUserMessageInfo}
      chatSessionId={chatSessionId}
      actionButton={null}
      readonly={false}
    />
  );
}
